import React from 'react';
import Breadcrumb from "../Shared/Breadcrumb/Breadcrumb";
import LimeDark from "../../images/lime-dark.svg";
import { portalTealBorder } from "../../theme/portalLayout";

function Header() {
  return (
    <div className="w-full">
      <div
        className={`flex flex-wrap items-center justify-between gap-md rounded-[12px] bg-portal-header-wash px-md py-sm ${portalTealBorder}`}
      >
        <img src={LimeDark} alt="Lime Health" className="h-[1.75rem] max-w-[12rem] object-contain object-left" />
        <span className="font-sans-co text-h4 font-bold text-portal-teal">Health Essentials</span>
      </div>
      <div className={`mt-sm rounded-[12px] bg-portal-header-wash px-md py-md ${portalTealBorder}`}>
        <Breadcrumb />
      </div>
    </div>
  );
}

export default Header;